import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';

const propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  field: PropTypes.string,
  fileTypes: PropTypes.string,
  validation: PropTypes.arrayOf(PropTypes.string),
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  id: null,
  value: false
};

export default class FileInput extends PureComponent {
  handleChange = (event) => {
    if (!event.target.files) {
      this.props.onChange(event);
    }

    this.props.onChange(
      {
        target: {
          dataset: {
            field: this.props.field
          },
          value: event.target.files[0]
        }
      }
    );
  }

  render() {
    const validation = !this.props.validation ? null : (
      <ul>{this.props.validation.map((err) => (
        <li key={err}>{err}</li>
      ))}
      </ul>
    );
    const validationCSS = this.props.validation && this.props.validation.length > 0 ? styles["validation-problems"] : "";
    const css = `${styles["text-input"]} ${this.props.required ? styles.required : ""} ${validationCSS}`;
    return (
      <div className={css}>
        <label htmlFor={this.props.id}>
          {this.props.label}
        </label>
        <input
          type="file"
          id={this.props.id}
          accept={this.props.fileTypes}
          onChange={this.handleChange} />
        {validation}
      </div>
    );
  }
}

FileInput.propTypes = propTypes;
FileInput.defaultProps = defaultProps;
